import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="components--calendar-modal"
export default class extends Controller {
  static targets = [
    "calendar"
  ]

  toggleCalendar(state) {
    if (state === "show") {
      this.calendarTarget.classList.remove("hidden")
    }

    if (state === "hide") {
      this.calendarTarget.classList.add("hidden")
    }
  }

  hideCalendar() {
    this.toggleCalendar("hide")
  }

  showCalendar() {
    this.toggleCalendar("show")
  }
}
